import {nodeTypeToImage} from "@/core/recoveryCoachingApp/coach/clients/ClientDetails/Genogram/GenogramEditor/defaults/node-types";

export const DECEASED_SYMBOL_LABEL = "Deceased"
export const STILLBIRTH_ABORTION_SYMBOL_LABEL = "Stillbirth / Abortion"
export const PREGNANCY_SYMBOL_TYPE = "triangle"

export function buildPassedAwayLegendItems(nodes = [], getNodeData = (node) => node) {
	let passedAwayCount = 0
	let passedAwayPregnancyCount = 0

	for(let node of nodes){
		let nodeData = getNodeData(node) || {}
		if(nodeData.isAuxNode || nodeData.excludeFromLegend || !nodeData.isPassedAway){
			continue
		}

		if(nodeData.type === PREGNANCY_SYMBOL_TYPE){
			passedAwayPregnancyCount++
			continue
		}

		passedAwayCount++
	}

	let items = []
	if(passedAwayCount > 0){
		items.push({
			count: passedAwayCount,
			type: "",
			title: DECEASED_SYMBOL_LABEL,
			isPassedAway: true,
		})
	}
	if(passedAwayPregnancyCount > 0){
		items.push({
			count: passedAwayPregnancyCount,
			type: PREGNANCY_SYMBOL_TYPE,
			src: nodeTypeToImage[PREGNANCY_SYMBOL_TYPE],
			title: STILLBIRTH_ABORTION_SYMBOL_LABEL,
			isPassedAway: true,
		})
	}

	return items
}
